import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FlightItinerary, AirAvailabiltyResult } from '@sabstravtech/obtservices/angular';
import { ServiceProvider, clone } from '@sabstravtech/obtservices/base';
import { NgForm } from '@angular/forms';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-flight-reprice-modal',
  templateUrl: './flight-reprice-modal.component.html',
  styleUrls: ['./flight-reprice-modal.component.scss'],
  standalone: false
})
export class FlightRepriceModalComponent implements OnInit {
  flight: FlightItinerary = null;
  availability: AirAvailabiltyResult[] = null;
  legCopies: any[] = [];
  serviceProvider: typeof ServiceProvider = ServiceProvider;
  @ViewChild('repriceForm') repriceForm: NgForm = new NgForm([], []);

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    console.log('+++ Flight Reprice modal opened! +++');
    console.log(this.flight);
    console.log(this.availability);
    this.legCopies = clone(this.flight.outboundFlights.concat(this.flight.inboundFlights));
    console.log(this.repriceForm);
  }

  close(): void {
    this.activeModal.close(false);
  }
}

LightningModalTypes.FlightRepriceModalComponent.component = FlightRepriceModalComponent;
